import { ButtonColor } from "@/common/enum/button-color";
import { OrderStatus } from "@/common/enum/order-status";
import { PaymentStatus } from "@/common/enum/payment-status";
import { formatDateToYYYYMMDD } from "@/common/util/date-util";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { Table } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { formatCommasNumber } from "../../../common/util/format-number-with-commas";
import { OrderDetailDto } from "../../../types/dto/order-detail-dto";
import { CustomCell } from "../CustomCell";

interface Props {
  data: OrderDetailDto;
  index: number;
  startIndex: number;
}

export const PartnerDetailOrderRow: React.FC<Props> = ({
  data,
  index,
  startIndex,
}) => {
  const navigate = useNavigate();
  const item = data;

  const orderStatus = OrderStatus.SHIPMENT_COMPLETED;
  const paymentStatus = PaymentStatus.PENDING;

  const getOrderStatusColor = (status: OrderStatus) => {
    switch (status) {
      case OrderStatus.RECEIVED:
        return ButtonColor.GREEN;
      case OrderStatus.CANCELLED:
        return ButtonColor.RED;
      default:
        return ButtonColor.CUSTOM_GRAY;
    }
  };

  const getPaymentStatusColor = (status: PaymentStatus) => {
    switch (status) {
      case PaymentStatus.PENDING:
      case PaymentStatus.CANCELED:
        return ButtonColor.RED;
      default:
        return ButtonColor.CUSTOM_GRAY;
    }
  };

  const handleClick = () => {
    window.open(`/order/details/${data.id}`, "_blank");
  };

  return (
    <Table.Row key={item.id} className="bg-primary-white">
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {startIndex - index}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell onClick={handleClick} className="cursor-pointer">
        <CustomCell>
          <Body14Underline className="text-semantic-text-body">
            {`${data.cartItems[0]?.name}`}{" "}
            {data.cartItems.length > 1 && `외 ${data.cartItems.length - 1}`}
          </Body14Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          {/* <Body14Regular className="text-secondary-2-red">{`${data.discount}%`}</Body14Regular> */}
          {`${formatCommasNumber(data.finalPriceSum)}원`}
          {/* <Body14Regular className="text-semantic-text-body">
            {data.}
            10%
          </Body14Regular>
          <Body14Regular className="text-semantic-text-body">
            {formatCommasNumber(data.finalPriceSum)}원
          </Body14Regular> */}
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Underline className="text-semantic-text-body">
            {data.constructionName}
          </Body14Underline>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatDateToYYYYMMDD(data.createdAt)}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
